import { useEffect, useState } from 'react'
type Device = 'mobile' | 'tablet' | 'desktop'

export const useResponsiveEnvironment = () => {
  const [isServer, setIsServer] = useState(true)
  const [device, setDevice] = useState<Device>('mobile')

  useEffect(() => {
    // useEffect is client side only
    setIsServer(false)

    const handleResize = () => {
      if (window.innerWidth < 768) {
        setDevice('mobile')
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        setDevice('tablet')
      } else {
        setDevice('desktop')
      }
    }

    // Initial check
    handleResize()

    // Listen for resize events
    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    isMobile: device === 'mobile' || isServer,
    isTablet: !isServer && device === 'tablet',
    isDesktop: !isServer && device === 'desktop',
  }
}
